import React from 'react';
import Select from 'react-select';
import UiComponent from '../UiComponent';

export default class ReactSelectWrapper extends UiComponent {

  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
      searchable: true,
      clearable: true,
    };
    this.updateValue = this.updateValue.bind(this);
  }

  componentDidMount() {
    if (this.props.field && this.props.field.system && this.props.field.system.disabled) {
      this.setState({disabled: true});
    }

    if (this.props.field && this.props.field.system && this.props.field.system.searchable === false) {
      this.setState({searchable: false});
    }

    if (this.props.field && this.props.field.system && this.props.field.system.clearable === false) {
      this.setState({clearable: false});
    }
  }

  updateValue(newValue) {
    if(newValue === null) {
      newValue = '';
    }

    this.props.field.value = newValue;
    this.props.onChange(this.props.field.name, this.props.field);
  }


  render() {
    const { autoFocus = true } = this.props;
    return (
      <div className="form-group">
        {this.getLabel()}
        <Select
          autosize={false}
          placeholder={this.props.placeholder}
          autoFocus={autoFocus}
          options={this.props.options}
          simpleValue
          clearable={this.state.clearable}
          name="selected-state"
          disabled={this.state.disabled || this.props.disabled}
          value={this.getFieldProp('value')}
          onChange={this.updateValue}
          searchable={this.state.searchable}
        />
        {this.getErrors()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/ReactSelectWrapper/index.js